// Maps English DB values to i18n keys for feature labels
const FEATURE_KEY_MAP = {
  // Group Sizes
  "Solo": "feature.solo",
  "Couple (2)": "feature.couple",
  "Small Group (3-5)": "feature.smallGroup",
  "Medium Group (6-10)": "feature.mediumGroup",
  "Large Group (10+)": "feature.largeGroup",

  // Dietary Options
  "Vegan": "feature.vegan",
  "Vegetarian": "feature.vegetarian",
  "Gluten-Free": "feature.glutenFree",
  "Halal": "feature.halal",
  "Kosher": "feature.kosher",
  "Dairy-Free": "feature.dairyFree",
  "Nut-Free": "feature.nutFree",

  // Event Types
  "Music": "feature.eventMusic",
  "Food & Drink": "feature.eventFoodDrink",
  "Workshop": "feature.eventWorkshop",
  "Family-Friendly": "feature.eventFamilyFriendly",
  "Arts & Culture": "feature.eventArtsCulture",
  "Sports": "feature.eventSports",
  "Nightlife": "feature.eventNightlife",
  "Other": "feature.eventOther",

  // Venue Types
  "Indoor": "feature.indoor",
  "Outdoor": "feature.outdoor",

  // Additional Features
  "Pet-Friendly": "feature.petFriendly",
  "Kid-Friendly": "feature.kidFriendly",
  "Adults Only (18+)": "feature.adultsOnly",
  "Has Special Offers": "feature.hasSpecialOffers",

  // Accessibility Features
  "Parking Available": "feature.parkingAvailable",
  "Wheelchair/Disabled Access": "feature.wheelchairAccess",
  "Disabled Toilets Available": "feature.disabledToilets",
  "Has Toilets": "feature.hasToilets",
};

/**
 * Translates a DB-stored English feature string using i18next.
 * Falls back to the original string if no mapping exists.
 * @param {Function} t - The i18next translation function
 * @param {string} value - The English DB value
 * @returns {string} Translated string
 */
export const tf = (t, value) => {
  const key = FEATURE_KEY_MAP[value];
  return key ? t(key, value) : value;
};
